import { RECEIVE_HISTORY, RECEIVE_LAST_DIFFERING } from "../actions/historyActions";

function combine(inputState, updates) {
    var state = Object.assign({}, inputState, updates);
    if (state.id && state.recommendations) {
        for (var r of state.recommendations) {
            if (r.id === state.id) {
                state.recommendation = r;
            }
        }
    }
    return state;
}

export default function (state = { }, action) {
    switch (action.type) {
        case RECEIVE_HISTORY:
            return combine(state, { recommendations: action.payload });
        case RECEIVE_LAST_DIFFERING:
            return combine(state, { id: action.payload });
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/recommendations/lastDifferingReducers.js
 **/